(() => {
  const init = root => {
    if (root.dataset.croReady) return;
    const section = root.closest('.product-section');
    const form = document.getElementById(root.dataset.formId);
    if (!section || !form) return;
    root.dataset.croReady = 'true';
    const labels = JSON.parse(root.querySelector('[data-cro-labels]').textContent);
    const variants = JSON.parse(root.querySelector('[data-main-variants]').textContent);
    const money = cents => new Intl.NumberFormat(root.dataset.locale || 'it', {style:'currency',currency:root.dataset.currency || 'EUR'}).format(cents/100);
    const extras = [...root.querySelectorAll('[data-cro-extra]')].map(el => ({el,check:el.querySelector('[data-extra-check]'),select:el.querySelector('[data-extra-variant]'),data:JSON.parse(el.querySelector('[data-extra-data]').textContent)}));
    const bar = root.querySelector('[data-cro-sticky]');
    const stickyButton = root.querySelector('[data-sticky-submit]');
    const status = root.querySelector('[data-cro-status]');
    const cartCheck = root.querySelector('[data-cro-cart-check]');
    const desktopButton = () => form.querySelector('[data-add-to-cart]');
    const mainVariant = () => variants.find(v=>String(v.id)===form.querySelector('[name="id"]')?.value);
    const quantity = () => {
      const field = form.elements.namedItem('quantity') || section.querySelector('[name="quantity"]');
      const qty = Number(field?.value || 1);
      return Number.isSafeInteger(qty) && qty>0 ? qty : 1;
    };
    const selectedExtras = () => extras.filter(e=>e.check.checked).map(e=>({...e,variant:e.data.variants.find(v=>String(v.id)===e.select.value && v.available)}));
    let busy=false, pastButton=false, requestLocked=false, observedButton=null;
    let selecting=false, selectionFailed=false, selectionToken=0, nativeLock=null;
    const variantChanging=()=>selecting||section.hasAttribute('data-kit-refresh-busy');
    const intersection='IntersectionObserver' in window ? new IntersectionObserver(entries=>{const entry=entries[entries.length-1];pastButton=!entry.isIntersecting && entry.boundingClientRect.bottom<0;updateVisibility();}) : null;
    const viewport=window.matchMedia('(max-width: 749px)');
    const text=(el,value)=>{if(el && el.textContent!==value)el.textContent=value;};
    const updateVisibility = () => {
      const dialogOpen=[...document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], .drawer--is-open, .modal--is-active, #shopify-pc__banner, .shopify-pc__banner')].some(el=>el.getClientRects().length>0 && getComputedStyle(el).visibility!=='hidden');
      const keyboardOpen=window.visualViewport && window.innerHeight-window.visualViewport.height>160;
      const inputFocused=document.activeElement?.matches('input:not([type="checkbox"]):not([type="radio"]),textarea,select');
      const show=viewport.matches && pastButton && !dialogOpen && !keyboardOpen && !inputFocused;
      bar.hidden=!show;
      document.body.classList.toggle('emal-cro-sticky-space',show);
    };
    const update = () => {
      const actualButton=desktopButton();
      const changing=variantChanging();
      if(actualButton && (changing||busy||requestLocked||selectionFailed)){
        if(nativeLock?.element!==actualButton)nativeLock={element:actualButton,disabled:actualButton.disabled};
        if(!actualButton.disabled)actualButton.disabled=true;
      }else if(nativeLock){
        if(nativeLock.element===actualButton && actualButton.disabled!==nativeLock.disabled)actualButton.disabled=nativeLock.disabled;
        nativeLock=null;
      }
      if(intersection && actualButton && actualButton!==observedButton){if(observedButton)intersection.unobserve(observedButton);observedButton=actualButton;intersection.observe(actualButton);}
      const current=mainVariant(),selected=selectedExtras(),pending=selected.some(e=>!e.variant);
      const total=current ? (Number(current.price)+selected.reduce((sum,e)=>sum+Number(e.variant?.price||0),0))*quantity() : 0;
      const totalBox=root.querySelector('[data-extra-total]');
      if(totalBox)totalBox.hidden=selected.length===0;
      text(root.querySelector('[data-extra-total-price]'),pending?'—':money(total));
      text(root.querySelector('[data-sticky-price]'),pending?'—':current?money(total):'—');
      text(root.querySelector('[data-sticky-caption]'),selected.length?labels.total:labels.main);
      const unavailable=current && !current.available;
      stickyButton.disabled=busy||requestLocked||selectionFailed||unavailable||changing||Boolean(desktopButton()?.disabled && current?.available);
      text(stickyButton,busy?labels.adding:unavailable?labels.sold:!current||pending?labels.choose:labels.add);
      updateVisibility();
    };
    extras.forEach(extra => {
      extra.check.disabled=false;
      extra.check.addEventListener('change',()=>{
        extra.select.disabled=!extra.check.checked;
        extra.select.required=extra.check.checked;
        if(!extra.check.checked)extra.select.value='';
        if(extra.check.checked && extra.data.variants.length===1 && extra.data.variants[0].available)extra.select.value=String(extra.data.variants[0].id);
        update();
        if(extra.check.checked && !extra.select.value)extra.select.focus({preventScroll:true});
      });
      extra.select.addEventListener('change',()=>{
        const v=extra.data.variants.find(v=>String(v.id)===extra.select.value);
        if(v){text(extra.el.querySelector('[data-extra-price]'),money(v.price));const image=extra.el.querySelector('img');const src=v.featured_image?.src || extra.data.image;image.removeAttribute('srcset');image.src=src;}
        update();
      });
    });
    stickyButton.addEventListener('click',()=>{
      update();if(stickyButton.disabled)return;
      const pending=selectedExtras().find(e=>!e.variant);
      if(pending){root.querySelector('[data-cro-extras]').open=true;pending.select.scrollIntoView({block:'center',behavior:'smooth'});pending.select.focus({preventScroll:true});text(status,labels.pending);return;}
      if(!mainVariant()){const picker=section.querySelector('kit-variant-picker');picker?.scrollIntoView({block:'center',behavior:'smooth'});picker?.querySelector('select,button,input')?.focus({preventScroll:true});return;}
      const button=desktopButton();if(button&&!button.disabled)form.requestSubmit(button);
    });
    // Capture before the theme's own Ajax handler. All selected items travel in one request.
    form.addEventListener('submit',async event=>{
      if(busy||requestLocked||variantChanging()||selectionFailed){event.preventDefault();event.stopImmediatePropagation();return;}
      if(!selectedExtras().length)return;
      event.preventDefault();event.stopImmediatePropagation();
      if(busy||requestLocked||section.hasAttribute('data-kit-refresh-busy'))return;
      const selected=selectedExtras(),main=mainVariant();
      const pending=selected.find(e=>!e.variant);
      if(pending){root.querySelector('[data-cro-extras]').open=true;pending.select.focus();text(status,labels.pending);return;}
      if(!main?.available || desktopButton()?.disabled || !form.reportValidity())return;
      busy=true;text(status,labels.adding);cartCheck.hidden=true;
      const controls=extras.flatMap(e=>[e.check,e.select]).map(el=>({el,disabled:el.disabled}));
      controls.forEach(c=>c.el.disabled=true);
      const pair=`Natale-${Date.now().toString(36)}-${Math.random().toString(36).slice(2,7)}`;
      const mainData=new FormData(form),properties={};
      for(const [key,value] of mainData){const match=key.match(/^properties\[(.+)\]$/);if(match&&typeof value==='string')properties[match[1]]=value;}
      properties[labels.pack_key]=labels.pack_main;properties[labels.pair_key]=pair;
      const items=[{id:main.id,quantity:quantity(),properties}];
      const sellingPlan=mainData.get('selling_plan');if(sellingPlan)items[0].selling_plan=sellingPlan;
      for(const extra of selected)items.push({id:extra.variant.id,quantity:quantity(),properties:{[labels.pack_key]:labels.pack_extra,[labels.pair_key]:pair}});
      update();
      try{
        const response=await fetch(root.dataset.cartAdd,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const data=await response.json();
        if(!response.ok)throw new Error(data.description||data.message||labels.error);
        location.assign(root.dataset.cartUrl);
      }catch(error){
        // A lost response can follow a successful addition: require a cart check before retrying.
        requestLocked=true;busy=false;controls.forEach(c=>c.el.disabled=c.disabled);cartCheck.hidden=false;
        text(status,error.message && error.message!==labels.error ? `${error.message} ${labels.error}` : labels.error);update();
      }
    },true);
    section.addEventListener('change',()=>{update();requestAnimationFrame(update);});
    section.addEventListener('shopify:product:select',event=>{
      const token=++selectionToken;selecting=true;selectionFailed=false;update();
      Promise.resolve(event.promise).then(()=>{
        if(token!==selectionToken)return;selecting=false;requestAnimationFrame(update);
      }).catch(()=>{
        if(token!==selectionToken)return;selecting=false;selectionFailed=true;text(status,labels.choose);requestAnimationFrame(update);
      });
    });
    const observer=new MutationObserver(update);
    observer.observe(form,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','value','class']});
    observer.observe(section,{attributes:true,attributeFilter:['data-kit-refresh-busy','aria-busy']});
    document.addEventListener('focusin',updateVisibility);document.addEventListener('focusout',()=>requestAnimationFrame(updateVisibility));
    document.addEventListener('click',()=>requestAnimationFrame(updateVisibility));
    new MutationObserver(updateVisibility).observe(document.body,{childList:true,subtree:true});
    viewport.addEventListener('change',updateVisibility);window.visualViewport?.addEventListener('resize',updateVisibility);
    document.addEventListener('cart:open',()=>{bar.hidden=true;document.body.classList.remove('emal-cro-sticky-space');});
    document.addEventListener('cart:close',updateVisibility);
    update();
  };
  const start=scope=>scope.querySelectorAll('[data-cro-purchase]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>start(document),{once:true});else start(document);
  document.addEventListener('shopify:section:load',event=>start(event.target));
})();
